import './static_page.less';
import './learn_more.less';

import classNames from 'classnames';
import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import ReactDOM from 'react-dom';
import {Link} from 'react-router';
import Header from '../header/header';
import Footer from '../footer/footer';
import HowItWorks from '../profile/how_it_works';
import HowItWorksDetails from '../profile/howItWorksDetailComponent.jsx';
import {shipperDetails} from '../landing/landing_data';
import DashBoardHeader from '../header_dashboard/dashboard_header';
import cookies from '../util/cookie';
import authActions from '../auth/auth_actions';

class LearnMore extends React.Component {

  constructor(props){
    super(props);
    this.logout = this.logout.bind(this);
  }

  logout() {
    this.props.authActions.logout().always(() => {
        cookies.delete('_sd');
        document.location.href = '/';
    });
  }

  render(){
    const self = this;
    const {state, props} = this;
    let user = {
      name: '',
      imageUrl: '',
      isVerified: ''
    };
    let isSessionValid = false;

    if('userData' in props.authState){
      isSessionValid  = props.authState.userData.sessionValid
    }

    if(isSessionValid && props.authState){
        user.name = props.authState.userData.name;
        user.imageUrl = props.authState.userData.profileImageUrl;
        user.isVerified = props.authState.userData.isVerified;
    }

    return(
      <div className="static-page" id="learnMoreWrap">
        {!isSessionValid && <Header isFixedHeader={true} />}
        {isSessionValid &&  <DashBoardHeader user = {user} logout={this.logout} />}
        <div className = {classNames('static-header-wrap', {'no-margin-top' : isSessionValid})}>
          <h1 className = "static-header">How AWB Works</h1>
        </div>
        <div className="static-page-wrapper">
          <HowItWorksDetails shipperObj = {shipperDetails} />
        </div>
        <Footer/>
      </div>
    )
  }
}

//connect Login modal and signup modal with actions and state
const mapStateToProps = (state) => {
  return {
    authState : state.app.auth || {}
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
      authActions : bindActionCreators(authActions, dispatch)
  }
}

LearnMore = connect(
  mapStateToProps,
  mapDispatchToProps
)(LearnMore)

export default LearnMore;



// WEBPACK FOOTER //
// app/static_pages/learn_more.jsx